import React from 'react';
import DocContainer from './DocContainer';

export default function App() {
  return (
    <>
      <DocContainer />
    </>
  );
}
